import type { GetDashboardAuditByIdResponseRow } from '@risksmart-app/drizzle/src/dto';
import { GetDashboardAuditByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

import type { AuditLogQueryResult } from './auditLogQueryResult';

type UseGetDashboardAuditByIdArgs = {
  id: string;
};

export const useGetDashboardAuditById = createQueryHook<
  UseGetDashboardAuditByIdArgs,
  GetDashboardAuditByIdResponseRow[],
  AuditLogQueryResult<'dashboard_audit', GetDashboardAuditByIdResponseRow>
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.auditLog.getDashboardAuditById.queryOptions({ id }),
  mapTrpcDataToGraphQL: (data) => ({ dashboard_audit: data }),
  graphqlDocument: GetDashboardAuditByIdDocument,
  graphqlVariables: ({ id }) => ({ Id: id }),
});
